import { render, staticRenderFns } from "./LocationsManagement.vue?vue&type=template&id=ef5d8fa2&scoped=true&"
import script from "./LocationsManagement.vue?vue&type=script&lang=js&"
export * from "./LocationsManagement.vue?vue&type=script&lang=js&"
import style0 from "./LocationsManagement.vue?vue&type=style&index=0&id=ef5d8fa2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef5d8fa2",
  null
  
)

export default component.exports